import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CollectingStatesService } from '../../collecting-states.service';
import { ModalService } from 'shared';
import { ColorClass } from 'shared';
import { BehaviorSubject, ReplaySubject, Subscribable, Subscription } from 'rxjs';
import { skip, take, takeUntil } from 'rxjs/operators';
import { AppComponent } from 'dm-src/app/app.component';
import { IosAndAndroidNatvieFunctionsService } from 'dm-src/services/ios-and-android-natvie-functions/ios-and-android-natvie-functions.service';
import { OfflineProductsService } from 'dm-src/app/modules/collecting/offline-products.service';
import { CollectingItemsService } from '../../collecting-items.service';
import { ProductIdentifyService } from '../../product-identify.service';

@Component({
    selector: 'app-product-identify-modal',
    templateUrl: './product-identify-modal.component.html',
    styleUrls: ['./product-identify-modal.component.scss'],
})
export class ProductIdentifyModalComponent implements OnInit, OnDestroy {
    private _destroy$: ReplaySubject<boolean>;
    private barcodeReadingStart: Subscription;
    public ColorClass = ColorClass;
    public barcode = '';

    constructor(
        private _states: CollectingStatesService,
        private _modalService: ModalService,
        private iosAndAndroidNatvieFunctionsService: IosAndAndroidNatvieFunctionsService,
        private _offlieProductsService: OfflineProductsService,
        public collectingItemsService: CollectingItemsService,
        public productIdentifyService: ProductIdentifyService
    ) {
        this._destroy$ = new ReplaySubject<boolean>(1);
    }

    ngOnInit(): void {
        this._states.isProductIdentifyModalVisible
            .pipe(skip(1))
            .pipe(takeUntil(this._destroy$))
            .subscribe((isVisible) => {
                if (isVisible) {
                    this.productIdentifyService.pendingAction = null;
                }
                this._modalService.setModalVisibility(
                    isVisible,
                    'product-identify-modal'
                );
            });
        if (window.ReactNativeWebView) {
            this.barcodeReadingStart = this.iosAndAndroidNatvieFunctionsService
                .getCurrentPostMessage()
                .pipe(takeUntil(this._destroy$))
                .subscribe((response) => {
                    if (response.functionName === 'BARCODE_READING_START') {
                        this._offlieProductsService.processGtin(response.result);
                    }
                });
        }
    }

    public selectOrder(orderID: number): void {
        const action = this.productIdentifyService.pendingAction;
        this.collectingItemsService.setDefaultStatedToSelectedMultiCollectingState(
            orderID
        );
        if (action) {
            this.cancel();
            this.productIdentifyService.run(action);
        }
    }

    public showBarcodeReaderModal(): void {
        this.cancel();
        this.productIdentifyService.openBarcodeReader();
    }

    public showManualSKUCheckModal(): void {
        this.cancel();
        this.productIdentifyService.openManualSKUCheck();
    }

    public onClosed(): void {
        this.productIdentifyService.pendingAction = null;
    }

    public cancel(): void {
        this._states.setProductIdentifyModalVisible(false);
    }

    ngOnDestroy(): void {
        this.iosAndAndroidNatvieFunctionsService.getAppVersion(); //we send this request just to stop sending barcodereading result from wrapper
        this.barcodeReadingStart?.unsubscribe();
        this._destroy$.next(true);
        this._destroy$.complete();
    }
}
